export const delay = ms => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(true);
    }, ms);
  });
};

/**
 * Декоратора debounce(f, wait)
 * когда мы вызываем debounce, это гарантирует, что все остальные вызовы будут игнорироваться в течение wait ms.
 */
export function debounce(
// eslint-disable-next-line no-unused-vars
func, wait = 0) {
  let timeout;
  function debounced(...args) {
    const context = this;
    const later = () => {
      func.apply(context, args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }
  debounced.clear = () => {
    clearTimeout(timeout);
  };
  return debounced;
}